"use strict";

var Constants = require("../designer/Constants");

var PhoneNumberHelper = {
	//When the phone number changes, this function is called to possibly adjust formatting
	handlePhoneNumberInputFormat: function (event, defaultCountry) {
		var $countryCode = $(event.target).closest("[data-component='accountPhoneNumberGroup']").find("input[data-component='accountPhoneCountryCode']");
		var countryCodeInputValue = $countryCode.val();
		var value = $(event.currentTarget).val() || "";
		if (countryCodeInputValue === "1" || countryCodeInputValue === "+1" || (!$countryCode.length && this.isCountryInUsOrCanada(defaultCountry))) {
			if (value.length === 4 && value.endsWith("-")) {
				//No more formatting is necessary
				return;
			}

			value = value.replace("-", "");
			if (value.length > 3) {
				value = `${value.substring(0, 3)}-${value.substring(3)}`;
			}
			if (value.length >= 8) {
				value = value.substring(0, 8);
			}

			$(event.currentTarget).val(value);
		}
	},

	//Main entry point for accountPhoneNumberGroup component
	initializePhoneNumberGroupComponent: function(defaultCountry, $parentComponent) {
		$parentComponent = $parentComponent || $("body");
		var $countryCodeInput = $parentComponent.find("[data-component='accountPhoneNumberGroup'] input[data-component='accountPhoneCountryCode']");
		//Defaulting the countryCode if necessary.
		if (!$countryCodeInput.val()) {
			if (this.isCountryInUsOrCanada(defaultCountry)) {
				$countryCodeInput.val("1");
			}
		}

		//When the area code changes (paste), making sure that if in US or Canada, only 3 characters are allowed.
		var $areaCodes = $parentComponent.find("[data-component='accountPhoneNumberGroup'] input[data-component='accountPhoneAreaCode']");
		$areaCodes.off("change.phoneNumberGroup");
		$areaCodes.on("change.phoneNumberGroup", (event) => {
			var $countryCode = $(event.target).closest("[data-component='accountPhoneNumberGroup']").find("input[data-component='accountPhoneCountryCode']");
			var countryCodeInputValue = $countryCode.val();
			var value = $(event.currentTarget).val() || "";
			if (countryCodeInputValue === "1" || countryCodeInputValue === "+1" || (!$countryCode.length && this.isCountryInUsOrCanada(defaultCountry))) {
				if (value.length >= 3) {
					value = value.substring(0, 3);
				}

				$(event.currentTarget).val(value);
			}
		});

		//For area code, making sure if a key is typed, and we are US or Canada and 3 characters are already present, do not allow character.
		$areaCodes.off("keydown.phoneNumberGroup");
		$areaCodes.on("keydown.phoneNumberGroup", (event) => {
			//If Ctrl or (Window for WindowsOS or Command for MacOS) or Alt key or some of the text is selected, allow the key down
			if (event.ctrlKey || event.metaKey || event.altKey || (event.currentTarget.selectionEnd - event.currentTarget.selectionStart > 0)) {
				return true;
			}
			switch (event.which) {
				case Constants.KEYS.DELETE:
				case Constants.KEYS.BACKSPACE:
				case Constants.KEYS.ARROW_UP:
				case Constants.KEYS.ARROW_RIGHT:
				case Constants.KEYS.ARROW_DOWN:
				case Constants.KEYS.ARROW_LEFT:
				case Constants.KEYS.TAB:
				case Constants.KEYS.ESCAPE:
				case Constants.KEYS.HOME:
				case Constants.KEYS.END:
				case Constants.KEYS.PAGE_UP:
				case Constants.KEYS.PAGE_DOWN:
					//event not handled, allowing the key down, as this is not a printable character
					return true;
				default:
					var $countryCode = $(event.target).closest("[data-component='accountPhoneNumberGroup']").find("input[data-component='accountPhoneCountryCode']");
					var countryCodeInputValue = $countryCode.val();
					var value = $(event.currentTarget).val() || "";
					if ((countryCodeInputValue === "1" || countryCodeInputValue === "+1" || (!$countryCode.length && this.isCountryInUsOrCanada(defaultCountry))) && value.length >= 3) {
						//event handled, do not allow key down, already at max characters
						return false;
					}
					//event not handled, allow the key down
					return true;
			}
		});

		//For phone number, making sure if a key is typed, and we are US or Canada and 8 characters are already present, do not allow character.
		var $phoneNumbers = $parentComponent.find("[data-component='accountPhoneNumberGroup'] input[data-component='accountPhoneNumber']");
		$phoneNumbers.off("keydown.phoneNumberGroup");
		$phoneNumbers.on("keydown.phoneNumberGroup", (event) => {
			//If Ctrl or (Window for WindowsOS or Command for MacOS) or Alt key or some of the text is selected, allow the key down
			if (event.ctrlKey || event.metaKey || event.altKey || (event.currentTarget.selectionEnd - event.currentTarget.selectionStart > 0)) {
				return true;
			}
			switch (event.which) {
				case Constants.KEYS.DELETE:
				case Constants.KEYS.BACKSPACE:
				case Constants.KEYS.ARROW_UP:
				case Constants.KEYS.ARROW_RIGHT:
				case Constants.KEYS.ARROW_DOWN:
				case Constants.KEYS.ARROW_LEFT:
				case Constants.KEYS.TAB:
				case Constants.KEYS.ESCAPE:
				case Constants.KEYS.HOME:
				case Constants.KEYS.END:
				case Constants.KEYS.PAGE_UP:
				case Constants.KEYS.PAGE_DOWN:
					//event not handled, allowing the key down, as this is not a printable character
					return true;
				default:
					var $countryCode = $(event.target).closest("[data-component='accountPhoneNumberGroup']").find("input[data-component='accountPhoneCountryCode']");
					var countryCodeInputValue = $countryCode.val();
					var value = $(event.currentTarget).val() || "";
					if (countryCodeInputValue === "1" || countryCodeInputValue === "+1" || (!$countryCode.length && this.isCountryInUsOrCanada(defaultCountry))) {
						if (value.length >= 8) {
							//event handled, do not allow key down, already at max characters
							return false;
						}
					}
					//event not handled, allow the key down
					return true;
			}
		});

		$phoneNumbers.off("change.phoneNumberGroup");
		$phoneNumbers.on("change.phoneNumberGroup", (event) => this.handlePhoneNumberInputFormat(event, defaultCountry));
		$phoneNumbers.off("keyup.phoneNumberGroup");
		$phoneNumbers.on("keyup.phoneNumberGroup", (event) => this.handlePhoneNumberInputFormat(event, defaultCountry));
	},

	isCountryInUsOrCanada: function(country) {
		country = (country || "").toUpperCase();
		if (country === "US" || country === "USA" || country === "CA" || country === "CAN") {
			return true;
		}

		return false;
	}
};

module.exports = PhoneNumberHelper;
